<template>
  <div class="preapproved">
    <b-container fluid>
      <b-row class="justify-content-center">
        <b-col md="9" xl="6">
          <b-card class="my-card" align="center">
            <b-card-title>
              Dickquist Quality Used Autos' Pre-Approval Form
            </b-card-title>
            <hr />
            <b-card-text>
              Need financing with our simple application you could find out if
              you are pre-approved in a few simple clicks. Just fill out this
              form and you will either be Pre-Approved! or a representative will
              follow up with you in a timely fashion and chances are we have a
              financing option that will work for you.
            </b-card-text>
            <br />

            <b-form
              :validated="validated"
              @submit.prevent="applyPreapproval"
              name="preapproval-form"
              novalidate
            >
              <div class="name">
                <label class="sr-only" for="form-input-name">Name</label>
                <b-input
                  id="form-input-name"
                  class="mb-2"
                  placeholder="Name"
                  required
                  v-model="name"
                  :state="isStateValid(this.name)"
                ></b-input>
                <b-form-invalid-feedback id="form-input-name">
                  You must enter a name
                </b-form-invalid-feedback>
              </div>

              <div class="address">
                <label class="sr-only" for="form-input-address">Address</label>
                <b-input
                  id="form-input-address"
                  class="mb-2"
                  placeholder="Address"
                  required
                  v-model="address"
                  :state="isStateValid(this.address)"
                ></b-input>
                <b-form-invalid-feedback id="form-input-address">
                  You must enter a address
                </b-form-invalid-feedback>
              </div>

              <div class="city">
                <label class="sr-only" for="form-input-city">City</label>
                <b-input
                  id="form-input-city"
                  class="mb-2"
                  placeholder="City"
                  required
                  v-model="city"
                  :state="isStateValid(this.city)"
                ></b-input>
                <b-form-invalid-feedback id="form-input-city">
                  You must enter a city
                </b-form-invalid-feedback>
              </div>

              <div class="state">
                <label class="sr-only" for="form-input-state">State</label>
                <b-input
                  id="form-input-state"
                  class="mb-2"
                  placeholder="State"
                  required
                  v-model="state"
                  :state="isStateValid(this.state)"
                ></b-input>
                <b-form-invalid-feedback id="form-input-state">
                  You must enter a state
                </b-form-invalid-feedback>
              </div>

              <div class="zip">
                <label class="sr-only" for="form-input-zip">Zip</label>
                <b-input
                  id="form-input-zip"
                  class="mb-2"
                  placeholder="Zip Code"
                  required
                  v-model="zip"
                  :state="isStateValid(this.zip)"
                ></b-input>
                <b-form-invalid-feedback id="form-input-zip">
                  You must enter a zip code
                </b-form-invalid-feedback>
              </div>

              <div class="phone-number">
                <label class="sr-only" for="form-input-phone-number"
                  >Phone Number</label
                >
                <b-input
                  id="form-input-phone-number"
                  class="mb-2"
                  placeholder="Phone Number"
                  required
                  v-model="phoneNumber"
                  :state="isStateValid(this.phoneNumber)"
                ></b-input>
                <b-form-invalid-feedback id="form-input-phone-number">
                  You must enter a phone number
                </b-form-invalid-feedback>
              </div>

              <b-input-group class="justify-content-center">
                <div class="email mr-2">
                  <label class="sr-only" for="inline-form-input-username"
                    >Email</label
                  >
                  <b-input
                    id="inline-form-input-username"
                    class="form-control mb-2"
                    placeholder="Email"
                    v-model="email"
                    required
                    :state="emailStateValidation"
                  ></b-input>
                  <b-form-invalid-feedback id="inline-form-input-username">
                    You must enter the part of your email that comes before the
                    '@' symbol
                  </b-form-invalid-feedback>
                </div>

                <div class="domain">
                  <label class="sr-only" for="inline-form-input-domain"
                    >Domain</label
                  >
                  <b-input-group prepend="@" class="mb-2">
                    <b-input
                      class="domain"
                      id="inline-form-input-domain"
                      placeholder="Domain ex: gmail.com"
                      v-model="domain"
                      :state="domainStateValidation"
                      required
                    ></b-input>
                    <b-form-invalid-feedback id="inline-form-input-domain">
                      You must enter the part of your email that comes after the
                      '@' symbol
                    </b-form-invalid-feedback>
                  </b-input-group>
                </div>
              </b-input-group>

              <div class="social">
                <label class="sr-only" for="form-input-social"
                  >Social Security Number</label
                >
                <b-input
                  id="form-input-social"
                  class="mb-2"
                  placeholder="Social Security Number"
                  required
                  v-model="social"
                  :state="socialStateValidation"
                ></b-input>
                <b-form-invalid-feedback id="form-input-social">
                  You must enter a valid social security number
                </b-form-invalid-feedback>
              </div>

              <div class="date">
                <label class="sr-only" for="example-datepicker"
                  >Choose a date</label
                >
                <b-form-datepicker
                  id="datepicker"
                  v-model="birthDate"
                  class="mb-2"
                  :max="maxBirthday"
                  required
                  placeholder="Birthday"
                  :state="isStateValid(this.birthDate)"
                ></b-form-datepicker>
                <b-form-invalid-feedback id="datepicker">
                  You must enter a valid birthday
                </b-form-invalid-feedback>
              </div>

              <div class="license">
                <label class="sr-only" for="form-input-license"
                  >Driver License Number</label
                >
                <b-input
                  id="form-input-license"
                  class="mb-2"
                  placeholder="Driver License Number"
                  required
                  v-model="driversLicense"
                  :state="isStateValid(this.driversLicense)"
                ></b-input>
                <b-form-invalid-feedback id="form-input-license">
                  You must enter a valid drivers license
                </b-form-invalid-feedback>
              </div>

              <div class="own-home">
                <b-form-group label="Own Home">
                  <b-form-radio-group
                    class="m-2"
                    id="radio-home"
                    v-model="ownHome"
                    :options="homeOptions"
                    buttons
                    name="radios-btn-default"
                    :state="isStateValid(this.ownHome)"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback
                    :state="isStateValid(this.ownHome)"
                    id="radio-home"
                  >
                    You must select whether you own a your home or rent.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>

              <div class="co-signer">
                <b-form-group label="Do you have a co-signer?">
                  <b-form-radio-group
                    class="m-2"
                    id="radio-cosign"
                    v-model="cosigner"
                    :options="options"
                    buttons
                    name="radios-btn-default"
                    :state="isStateValid(this.cosigner)"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback
                    :state="isStateValid(this.cosigner)"
                    id="radio-cosign"
                  >
                    You must select whether you have a cosigner or not.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>

              <div class="working">
                <b-form-group label="Are You Currently Working?">
                  <b-form-radio-group
                    class="m-3"
                    id="radios-working"
                    v-model="currentlyWorking"
                    :options="options"
                    buttons
                    name="radios-btn-default"
                    :state="isStateValid(this.currentlyWorking)"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback
                    :state="isStateValid(this.currentlyWorking)"
                    id="radios-working"
                  >
                    You must select whether you are working or not.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>

              <div v-show="this.currentlyWorking == 'Yes'">
                <div class="employer">
                  <label class="sr-only" for="form-input-employer"
                    >Employer's Name</label
                  >
                  <b-input
                    id="form-input-employer"
                    class="mb-2"
                    placeholder="Employer's Name"
                    required
                    v-model="employer"
                    :state="isStateValid(this.employer)"
                  ></b-input>
                  <b-form-invalid-feedback id="form-input-employer">
                    You must enter a employer
                  </b-form-invalid-feedback>
                </div>

                <div class="employment-length">
                  <label for="sb-step" class="mb-2"
                    >Length of Employment (in years)</label
                  >
                  <b-form-spinbutton
                    class="mb-2"
                    id="sb-step"
                    v-model="employmentLength"
                    min="0"
                    max="100"
                    step="0.25"
                    :state="isStateValid(this.employmentLength)"
                  ></b-form-spinbutton>
                  <b-form-invalid-feedback id="form-input-employment-length">
                    Please choose the option closets to the amount of time you
                    have been employed. You must choose an option greater than
                    zero.
                  </b-form-invalid-feedback>
                </div>
              </div>

              <div class="income">
                <label class="sr-only" for="form-input-income"
                  >Average Monthly Income</label
                >
                <b-input
                  id="form-input-income"
                  class="mb-2"
                  placeholder="Average Monthly Income"
                  required
                  v-model="income"
                  :state="isStateValid(this.income)"
                ></b-input>
                <b-form-invalid-feedback id="form-input-income">
                  You must enter a employer
                </b-form-invalid-feedback>
              </div>

              <div class="payment">
                <label class="sr-only" for="form-input-payment"
                  >Preferred Monthly Payment</label
                >
                <b-input
                  id="form-input-payment"
                  class="mb-3"
                  placeholder="Preferred Monthly Payment"
                  required
                  v-model="preferredPayment"
                  :state="isStateValid(this.preferredPayment)"
                ></b-input>
                <b-form-invalid-feedback id="form-input-payment">
                  You must enter a employer
                </b-form-invalid-feedback>
              </div>

              <b-button type="submit" @click="validate()">Apply</b-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import firebase from "@/firebase/init";

  export default {
    name: "Preapproved",
    data() {
      return {
        name: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        phoneNumber: "",
        username: "",
        domain: "",
        social: "",
        birthDate: "",
        driversLicense: "",
        ownHome: "",
        cosigner: "",
        currentlyWorking: "",
        employer: "",
        employmentLength: 0,
        income: "",
        preferredPayment: "",
        validated: false,
        maxBirthday: new Date(),
        homeOptions: [
          { text: "Own", value: "Home" },
          { text: "Rent", value: "Rent" },
        ],
        options: [
          { text: "Yes", value: "Yes" },
          { text: "No", value: "No" },
        ],
      };
    },
    computed: {
      emailStateValidation() {
        if (this.username) {
          return this.emailIsValid() ? true : false;
        }
        return null;
      },
      domainStateValidation() {
        if (this.domain) {
          return this.domainIsValid() ? true : false;
        }
        return null;
      },
      socialStateValidation() {
        if (this.social) {
          return this.socialIsValid() ? true : false;
        }
        return null;
      },
    },
    methods: {
      emailIsValid() {
        let regEx = /^(?!.*@)((^[^\.])[a-z0-9\.!#$%&'*+\-\/=?^_`{|}~"]*)*([^\.]$)/;
        return regEx.test(this.username);
      },
      domainIsValid() {
        let regEx = /((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regEx.test(this.domain);
      },
      socialIsValid() {
        if (this.social.length >= 9 && !isNan(this.social)) {
          return true;
        } else return false;
      },
      isStateValid(variable) {
        if (this.validated) {
          return variable.length > 0 ? true : false;
        }
        return null;
      },
      validate() {
        this.validated = true;
      },
      applyPreapproval() {
        firebase
          .firestore()
          .collection("preapproval")
          .add({
            uid: Date.now().toString() + Math.floor(Math.random() * 1000 + 1),
            name: this.name,
            address: this.address,
            city: this.city,
            state: this.state,
            zip: this.zip,
            phonenumber: this.phoneNeumber,
            email: this.username + "@" + this.domain,
            social: this.social,
            timestamp: Date.now(),
            birthDate: this.birthDate,
            driversLicense: this.driversLicense,
            employersName: this.employersName,
            employmentLength: this.employmentLength,
            workStatus: this.workStatus,
            homeStatus: this.homeStatus,
            cosignStatus: this.cosignStatus,
            preferredPayment: this.preferredPayment,
          })
          .then(() => {
            var frm = document.getElementsByName("preapproval-form")[0];
            frm.reset(); // Reset all form data
          })
          .catch((err) => {
            alert("We are sorry an error has occured please try again later");
            console.log(err.message);
          });
      },
    },
  };
</script>

<style lang="scss"></style>
